import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/Card';
import { Button } from '../components/ui/Button';
import { Badge } from '../components/ui/Badge';
import { Share2, CheckCircle2, AlertCircle, ArrowLeft } from 'lucide-react';
export function APIConnectionPage() {
  const navigate = useNavigate();
  const {
    user,
    updateUser
  } = useAuth();
  const [isConnecting, setIsConnecting] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const handleConnect = async () => {
    setIsConnecting(true);
    setTimeout(() => {
      setIsConnecting(false);
      setIsSuccess(true);
      updateUser({
        instagramConnected: true
      });
      setTimeout(() => {
        navigate('/creator');
      }, 1500);
    }, 2000);
  };
  return <div className="min-h-screen bg-gray-50 flex items-center justify-center p-4" data-id="element-368">
      <Card className="w-full max-w-2xl" data-id="element-369">
        <CardHeader data-id="element-370">
          <div className="flex items-center justify-between mb-4" data-id="element-371">
            <Button variant="ghost" size="sm" onClick={() => navigate('/creator')} data-id="element-372">
              <ArrowLeft className="h-4 w-4 mr-2" data-id="element-373" /> Back
            </Button>
            <Badge variant={user?.instagramConnected ? 'success' : 'secondary'} data-id="element-374">
              {user?.instagramConnected ? 'Connected' : 'Not Connected'}
            </Badge>
          </div>
          <div className="text-center space-y-4" data-id="element-375">
            <div className="mx-auto h-20 w-20 bg-gradient-to-tr from-blue-500 to-purple-600 rounded-2xl flex items-center justify-center text-white shadow-lg" data-id="element-376">
              <Share2 className="h-10 w-10" data-id="element-377" />
            </div>
            <CardTitle className="text-3xl font-bold" data-id="element-378">
              Connect Social Media
            </CardTitle>
            <p className="text-muted-foreground max-w-md mx-auto" data-id="element-379">
              Connect your social media accounts to unlock powerful analytics
              and share real-time data with brands.
            </p>
          </div>
        </CardHeader>
        <CardContent className="space-y-8" data-id="element-380">
          {isSuccess ? <div className="bg-green-50 border border-green-200 rounded-lg p-6 text-center animate-in fade-in zoom-in duration-300" data-id="element-381">
              <CheckCircle2 className="h-12 w-12 text-green-500 mx-auto mb-4" data-id="element-382" />
              <h3 className="text-lg font-semibold text-green-900 mb-2" data-id="element-383">
                Successfully Connected!
              </h3>
              <p className="text-green-700" data-id="element-384">
                Redirecting you back to your dashboard...
              </p>
            </div> : <>
              <div className="bg-blue-50 border border-blue-100 rounded-lg p-6" data-id="element-385">
                <h4 className="font-semibold text-blue-900 mb-4 flex items-center" data-id="element-386">
                  <AlertCircle className="h-5 w-5 mr-2" data-id="element-387" />
                  Why connect your account?
                </h4>
                <ul className="space-y-3 text-sm text-blue-800" data-id="element-388">
                  <li className="flex items-start" data-id="element-389">
                    <CheckCircle2 className="h-4 w-4 mr-2 mt-0.5 shrink-0 opacity-70" data-id="element-390" />
                    <span data-id="element-391">
                      Access detailed follower demographics and growth metrics
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-392">
                    <CheckCircle2 className="h-4 w-4 mr-2 mt-0.5 shrink-0 opacity-70" data-id="element-393" />
                    <span data-id="element-394">
                      Track engagement rates across all your posts and stories
                    </span>
                  </li>
                  <li className="flex items-start" data-id="element-395">
                    <CheckCircle2 className="h-4 w-4 mr-2 mt-0.5 shrink-0 opacity-70" data-id="element-396" />
                    <span data-id="element-397">Generate professional media kits automatically</span>
                  </li>
                </ul>
              </div>

              <div className="space-y-4" data-id="element-398">
                <div className="text-sm text-gray-500 text-center" data-id="element-399">
                  By connecting, you agree to share your public profile
                  information and media insights.
                </div>
                <Button variant="gradient" size="lg" className="w-full h-12 text-lg" onClick={handleConnect} disabled={isConnecting || user?.instagramConnected} data-id="element-400">
                  {isConnecting ? 'Connecting...' : user?.instagramConnected ? 'Account Connected' : 'Connect Account'}
                </Button>
              </div>
            </>}
        </CardContent>
      </Card>
    </div>;
}